import { Warning } from '@mui/icons-material';
import { Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';
import { GenConfirmationDialog } from '../GenDialogs';

const ResumeModal = ({
  open,
  vendorOrderId,
  handleOpenState,
  statusChange,
  setCurrentLoadingButton,
  isApiLoading,
}) => {
  const { t } = useTranslation('workOrderStepper');

  const handleCloseClick = useCallback(() => {
    handleOpenState(false);
    setCurrentLoadingButton(null);
  }, [handleOpenState, setCurrentLoadingButton]);

  const handleOnConfirm = () => {
    statusChange(ProcessStep.ARRIVED, vendorOrderId);
  };

  useEffect(() => {
    if (!isApiLoading) {
      handleCloseClick();
    }
  }, [isApiLoading, handleCloseClick]);

  return (
    <GenConfirmationDialog
      open={open}
      title={t('wOStepperResumePopUp.title')}
      titleIcon={Warning}
      titleIconColor="warning"
      closeText={t('wOStepperResumePopUp.close')}
      onClose={handleCloseClick}
      onRefuse={handleCloseClick}
      confirmText={t('wOStepperResumePopUp.confirm')}
      onConfirm={handleOnConfirm}
      isLoading={isApiLoading}
      children={
        <Grid container direction="column" alignItems="center">
          <Grid item width="100%">
            <Typography
              variant="body1"
              color="textSecondary"
              textAlign="center"
              mb={3}
            >
              {t('wOStepperResumePopUp.subtitle')}
            </Typography>
          </Grid>
        </Grid>
      }
    />
  );
};

export default ResumeModal;
